import { SharedService } from '@app/_services/shared.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { RootService } from '@services/root.service';
import { ShopService } from '@shared/api/shop.service';
import { CategoryPageService } from '@app/_services/categoryPage.service';
import * as _ from 'lodash';
import { HomepageService } from '@app/_services/homepage.service';

@Injectable({
    providedIn: 'root'
})
export class CategoryProductsResolverService {
    constructor(
        private root: RootService,
        private router: Router,
        private categoryPageService: CategoryPageService,
        private sharedService: SharedService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        const categorySlug = route.params.slug || route.data.slug || null;
        this.sharedService.currentCategorySubject$.next(categorySlug);

        let params: any = {
            page: 1,
            limit: this.sharedService.paginations.limit,
            sort: 'popular'
        }
        if (!_.isEmpty(route.queryParams)) {
            params = route.queryParams;
        }
        if (categorySlug === null) {
            // console.log('CATEGORY SLUG IS NULL')
            return null;
        }
        return this.categoryPageService.getProducts(categorySlug, params).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 404) {
                    this.router.navigateByUrl('/not-found').then();
                }

                return EMPTY;
            }),
            tap(data => {
                if (data.category?.path?.length) {
                    this.sharedService.currentCategorySubject$.next(data.category?.path[0].seo?.slug);
                }
            })
        );

    }
}
@Injectable({
    providedIn: 'root'
})
export class MainCategoryResolverService {
    constructor(
        private homepageService: HomepageService,
    ) { }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.homepageService.getMainCategories();
    }
}
